// Slice 41 — radio + checkbox primitives. Rendered as buttons so they can
// live anywhere (cards, chip-toggles) — the visual is the part the design
// pins; aria-pressed conveys state to assistive tech.

export interface HqRadioProps {
  checked: boolean;
  onChange: (v: boolean) => void;
  ariaLabel?: string;
}

export function HqRadio({ checked, onChange, ariaLabel }: HqRadioProps) {
  return (
    <button
      type="button"
      role="radio"
      aria-checked={checked}
      aria-label={ariaLabel ?? "Radio"}
      onClick={() => onChange(!checked)}
      style={{
        width: 16,
        height: 16,
        borderRadius: 99,
        background: "var(--hq-bg-input)",
        border: `1.5px solid ${checked ? "var(--hq-accent)" : "var(--hq-border-strong)"}`,
        display: "inline-grid",
        placeItems: "center",
        cursor: "pointer",
        padding: 0,
      }}
    >
      {checked && (
        <span
          style={{
            width: 7,
            height: 7,
            borderRadius: 99,
            background: "var(--hq-accent)",
            display: "inline-block",
          }}
        />
      )}
    </button>
  );
}

export interface HqCheckboxProps {
  checked: boolean;
  onChange: (v: boolean) => void;
  ariaLabel?: string;
}

export function HqCheckbox({ checked, onChange, ariaLabel }: HqCheckboxProps) {
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={checked}
      aria-label={ariaLabel ?? "Checkbox"}
      onClick={() => onChange(!checked)}
      style={{
        width: 16,
        height: 16,
        borderRadius: 4,
        background: checked ? "var(--hq-accent)" : "var(--hq-bg-input)",
        border: `1.5px solid ${checked ? "var(--hq-accent)" : "var(--hq-border-strong)"}`,
        display: "inline-grid",
        placeItems: "center",
        cursor: "pointer",
        padding: 0,
      }}
    >
      {checked && (
        <svg width="10" height="10" viewBox="0 0 12 12" aria-hidden="true" focusable="false">
          <path
            d="M2 6l2.5 2.5L10 3"
            stroke="#04101a"
            strokeWidth="2"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </button>
  );
}
